import { LICENSES } from "src/app/core/modules";
import { Regions } from "src/app/services/feature-access-control/region.service";

export enum IntegrationPropertyType {
  STRING = "string",
  NUMBER = "number",
  BOOLEAN = "boolean"
}

export type IntegrationProperty = {
  name: string;
  label: string;
  type: IntegrationPropertyType;
};

export interface Integration {
  id: string;
  name: string;
  description?: string;
  icon?: string;
  images?: string[];
  authorizationUrl?: string;
  authentication: IntegrationAuthenticationModel;
  clientId?: string;
  clientSecret?: string;
  properties?: IntegrationProperty[];
  multiUser?: boolean;
  provider: string;

  descriptionLong: string;
  plans: LICENSES[];
  regions: Regions[];
  developer: string;
  price: number | "free" | "forAFee";
  pricePeriod?: "month" | "year";
  categories: string[];
  publishedOn: string;
  updatedOn: string;

  pricing: {
    type: "free" | "subscription";
    price?: number;
  };

  new?: boolean;
}

interface IntegrationAuthenticationModel {
  type: IntegrationAuthenticationType;
  configuration:
    | IntegrationBasicConfigurationModel
    | IntegrationOauth2ConfigurationModel
    | IntegrationCustomConfigurationModel[]
    | undefined;
}

export enum IntegrationAuthenticationType {
  NONE = "none",
  BASIC = "basic",
  OAUTH2 = "oauth2",
  CUSTOM = "custom"
}

interface IntegrationBasicConfigurationModel {}

interface IntegrationOauth2ConfigurationModel {
  authorizationBaseUrl: string;
  tokenBaseUrl: string;
  scope: string;
  clientId: string;
  clientSecret: string;
}

export interface IntegrationCustomConfigurationModel {
  label: string;
  name: string;
  type: string;
}
